export const parametersTypes = [
    {value: 1, label: "INTEIRO", inputType: "number"},
    {value: 2, label: "DECIMAL", inputType: "text"},
    {value: 3, label: "BOOLEANO", inputType: "boolean"},
    {value: 4, label: "JSON", inputType: "text"},
    {value: 5, label: "EMAIL", inputType: "email"},
    {value: 6, label: "TEXTO", inputType: "text"}
];

export const defaultStylesSelectLib = {
    control: (provided) => ({
        ...provided,
        border: "1px solid #dce4ec",
        boxShadow: "inset 0 1px 1px rgb(0 0 0 / 8%)",
        height: "35px",
    }),
    valueContainer: (provided) => ({...provided, height: "100%", width: "auto", overflow: "visible"}),
    singleValue: (provided) => ({...provided, height: "100%", width: "100%", display: "flex", alignItems: "center"}),
    indicatorsContainer: (provided) => ({...provided, position: "absolute", right: 0, width: "10%"}),
    input: (provided) => ({...provided, height: "35px"})
}

export const customStyleSelect = {
    control: ((style) => ({
        ...style,
        height: "35px",
        border: "1px solid #dce4ec",
        borderRadius: "5px"
    })),
    valueContainer: ((style) => ({
        ...style,
            height: "35px",
    })),
    singleValue: ((style) => ({
        ...style,
        verticalAlign: "center",
    })),
    placeholder: ((style) => ({
        ...style,
        verticalAlign: "center",
        marginBottom: "0.5rem"
    }))
}